import { render, staticRenderFns } from "./SelectSuit.vue?vue&type=template&id=010223fa&scoped=true&"
import script from "./SelectSuit.vue?vue&type=script&lang=js&"
export * from "./SelectSuit.vue?vue&type=script&lang=js&"
import style0 from "./SelectSuit.vue?vue&type=style&index=0&id=010223fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010223fa",
  null
  
)

export default component.exports